/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentGoCampaign_PoliticalDistricts.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Political District API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Wednesday, July 10, 2019 - 12:15:48 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      07/10/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const GoCampaign_PoliticalDistricts = {
    all: (politicaldistrictgroupid) => requests.get(`/PoliticalDistricts?politicaldistrictgroupid=${politicaldistrictgroupid}`),
    get: politicaldistrictid => requests.get(`/PoliticalDistrict/${politicaldistrictid}`),
    create: politicaldistrict => requests.post(`/PoliticalDistricts`, politicaldistrict),
    update: (politicaldistrictid, politicaldistrict) => requests.put(`/PoliticalDistrict/${politicaldistrictid}`, politicaldistrict),
    delete: politicaldistrictid => requests.del(`/PoliticalDistrict/${politicaldistrictid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentGoCampaign_PoliticalDistricts.js